import { call, put, select, takeLatest, takeLeading } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import { resourceService } from '@libs/axios';
import { fetchMyPermissions, LoginSuccessPayload } from '@store/actions/authActions';
import { loginSuccess, RbacState, setRbac } from '@store/reducers/authReducer';
import type { AppState } from '@store/index';

const API_URL = process.env.REACT_APP_API_URL;

// Nhiều API cùng trả 403 một lúc chỉ cần tải lại quyền một lần
const MIN_REFRESH_INTERVAL_MS = 5000;
let lastFetchedAt = 0;

// Không tải được quyền (BE cũ chưa có API...): FE không chặn gì, BE vẫn kiểm tra
const RBAC_UNAVAILABLE: RbacState = {
    role_type: null,
    is_super_admin: false,
    mode: 'off',
    permissions: [],
    failed: true,
};

function* fetchMyPermissionsSaga(): Generator<any, void, any> {
    const auth = yield select((state: AppState) => state.auth);
    if (!auth?.access_token) return;
    if (auth.rbac && Date.now() - lastFetchedAt < MIN_REFRESH_INTERVAL_MS) return;
    // Tính cả lần gọi lỗi: /api/rbac/me/ lỗi liên tục thì 403 cũng không gọi lại dồn dập
    lastFetchedAt = Date.now();
    try {
        const response: any = yield call(resourceService.get, `${API_URL}/api/rbac/me/`);
        // /api/rbac/me/ trả cùng dạng với field "rbac" của response login
        const data = response.data;
        yield put(setRbac(Array.isArray(data?.permissions) ? data : RBAC_UNAVAILABLE));
    } catch (error) {
        console.error(error);
        // Giữ quyền đang có; chưa có thì coi như không tải được
        if (!auth.rbac) yield put(setRbac(RBAC_UNAVAILABLE));
    }
}

// Login SSO (và login thường khi BE chưa trả rbac): tải quyền ngay sau khi đăng nhập
function* afterLoginSaga(action: PayloadAction<LoginSuccessPayload>): Generator<any, void, any> {
    if (!action.payload.rbac) {
        lastFetchedAt = 0;
        yield put(fetchMyPermissions());
    }
}

function* permissionSaga() {
    yield takeLeading(fetchMyPermissions.type, fetchMyPermissionsSaga);
    yield takeLatest(loginSuccess.type, afterLoginSaga);
    // Mở / tải lại app khi đã đăng nhập: quyền trong localStorage có thể đã cũ
    yield put(fetchMyPermissions());
}

export default permissionSaga;
